import styled from "styled-components";

export const StyledJobs = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const StyledJobsContent = styled.div`
    padding: 40px;
    height: 100%;
`;